"use client"

import { useEffect } from "react"

import Link from "next/link"

import useUserStore from "@/store/userStore"

import { Plus, GalleryVerticalEnd, Crown, ChartNoAxesColumnIncreasing } from "lucide-react"
import { usePathname } from "next/navigation"

export const menuItems = [
    {
        href: "/create",
        icon: Plus,
        label: "Create New LipSync"
    },
    {
        href: "/projects",
        icon: GalleryVerticalEnd,
        label: "My Projects"
    },
    {
        href: "/subscription",
        icon: Crown,
        label: "Subscription"
    },
    {
        href: "/usage",
        icon: ChartNoAxesColumnIncreasing,
        label: "Usage"
    }
]

const AppSidebar = () => {

    const pathname = usePathname()
    const { userCredits, userPlan, setUserPlan } = useUserStore()

    // useEffect(() => {
    //     setUserPlan(userPlan)
    // }, [userPlan])

    return (
        // Prevent browser auto-translation from mutating DOM inside the React-managed sidebar.
        // Auto-translation can wrap text nodes and break React unmount/reconcile during navigation,
        // causing: "Failed to execute 'removeChild' on 'Node'..."
        <div className="w-[240px] h-screen bg-base-100 border-r border-base-200 hidden lg:flex flex-col">
            <div className="flex-1">
                <a href="/" className="flex items-center justify-start p-4 gap-2 mt-4">
                    <img src="/logo.svg" alt="logo" className="w-10 h-10" />
                    <div className="font-bold">LipSync.Show</div>
                </a>

                <ul className="menu w-full rounded-box">
                    {menuItems.map((item) => (
                        <li key={item.href}>
                            <Link href={item.href} className={`py-3 px-5 ${pathname === item.href ? "bg-base-300" : ""}`}>
                                <item.icon size={18} />
                                <span className="ml-2">{item.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            {/* bottom */}
            <div className="w-full p-2 flex items-center justify-center">
                <div className="p-4 rounded-2xl" style={{ background: "linear-gradient(196deg,rgba(60, 0, 112, 1) 0%, rgba(14, 0, 43, 1) 29%, rgba(46, 18, 0, 1) 75%, rgba(117, 68, 0, 1) 100%)" }}>
                    {/* row 1 */}
                    <div className="flex justify-between items-center h-8">
                        <div className="flex items-center gap-2">
                            <img src="/credits.svg" alt="" className='w-4 h-4' />
                            {userCredits !== null ? userCredits : (<div className="loading loading-spinner loading-xs"></div>)}
                        </div>

                        <div className="badge badge-primary badge-sm font-bold">{userPlan !== null ? userPlan.split('-')[0].charAt(0).toUpperCase() + userPlan.split('-')[0].slice(1) : "--"}</div>
                    </div>

                    {/* row 2 */}
                    <div className="mt-6 mb-2 text-xs text-base-content/85">Need more? Upgrade your plan</div>

                    {/* row 3 */}
                    <Link href="/pricing" className="btn bg-base-100 w-full text-warning">Upgrade now</Link>
                </div>
            </div>
        </div>
    )
}

export default AppSidebar
